import React from "react";
import { useSelector } from "react-redux";
import classes from "./HoldersPopup.module.css";

const HoldersPopup = ({ holders }) => {
    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.PopupContent}>
            <p className={classes.PopupTitle}>{texts.allPermissionHolders}</p>
            <div className={classes.PopupList}>
                {holders.map((holder) => (
                    <div key={holder.id} className={classes.PopupRow}>
                        <span className={classes.PopupName}>
                            {`${holder.firstName} ${holder.lastName}`}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HoldersPopup;
